import {createSlice} from "@reduxjs/toolkit";
import {fetchProgram} from "../Functions/fetchProgram";
import store from "storejs";

const initialState = {
    program: [],
    lecturers: [],
    loading: false,
    error: null,
}

export const ProgramSlice = createSlice({
    name: 'program',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchProgram.pending, state => {
                state.loading = true
                state.error = null
            })
            .addCase(fetchProgram.fulfilled, (state, action) => {
                state.loading = false
                state.program = action.payload.program
                state.lecturers = action.payload.lecturers
            })
            .addCase(fetchProgram.rejected, (state, action) => {
                state.loading = false
                state.error = action.error.message || 'Something went wrong'
            })
    },
})

export const programReducer = ProgramSlice.reducer;

export const selectProgram = (state) => state.data.program||store('lecturers')||[]
export const selectLecturers = (state) => state.data.lecturers||[]
export const selectLoading = (state) => state.data.loading
export const selectError = (state) => state.data.error
